import axios from 'axios';

export default {
    search (query) {
        return axios
            .get('/api/candidates', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search,
                    duplicates: query.duplicates
                }
            })
            .catch(error => {
                return error.response;
            });
    },

    finances (query) {
        return axios
            .get('/api/finances', {
                params: {
                    per_page: query.perPage,
                    current_page: query.currentPage,
                    page: query.page,
                    search: query.search
                }
            })
            .catch(error => {
                return error.response;
            });
    },

    candidateAccounts (query) {
        return axios
            .get('/api/accounts', {
                params: {
                    search: query
                }
            })
            .catch(error => {
                return error.response;
            });
    },
    exportCandidateAccounts (query) {
        return axios
            .get('/api/export_accounts', {
                responseType: 'blob',
                params: {
                    search: query
                }
            })
            .then(function (response) {
                return response;
            });
    },

    exportUsers (query) {
        return axios
            .get('/api/candidates/export', {
                responseType: 'blob',
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportApplications (query) {
        return axios
            .get('/api/applications/export', {
                responseType: 'blob',
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },
    exportApplicationsToSchedule (query) {
        return axios
            .get('/api/applications_to_schedule/export', {
                responseType: 'blob',
                params: {
                    search: query.search,
                    fields: query.fields
                }
            })
            .then(function (response) {
                return response;
            });
    },
    addApplicationSchedules (data) {
        return axios.post('/api/applications_to_schedule/add_schedules', data);
    },
    delApplicationSchedules (data) {
        return axios.post('/api/applications_to_schedule/del_schedules', data);
    },

    importUsers (file) {
        return axios.post('/api/candidates/import', file);
    },

    importParcourSup (file) {
        return axios
            .post('/api/candidates/import_parcoursup', file)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    deleteUser (data) {
        return axios.post('/api/candidate/account/delete', data);
    },

    showUser (id) {
        return axios.get('/api/candidate/' + id);
    },

    updateUser (id, query) {
        return axios.post('/api/candidate/' + id + '/edit', query);
    },

    monitorCandidate (id, query) {
        return axios.post('/api/candidate/' + id + '/monitor', query);
    },

    origins() {
        return axios.get("/api/candidates/origins");
    },

    bulkUpdateOrigin(data) {
        return axios
            .post('/api/candidates/bulk-update-origin', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

// Méthode pour la mise à jour individuelle de l'origine
    updateIndividualOrigin(id, data) {
        return axios
            .post(`/api/candidates/update-origin/${id}`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    sendBulkMessage (message) {
        return axios
            .post('/api/candidates/bulk_message/send', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteBulkMessage (message) {
        return axios
            .post('/api/candidates/bulk_message/delete', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    bulkMessages () {
        return axios
            .get('/api/candidates/bulk_messages')
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    }
};
